<script setup>
import { useMapGetter } from 'dashboard/composables/store';

const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <span class="flex w-full shrink-0 justify-center">
    <img
      :src="globalConfig.logo"
      :alt="globalConfig.installationName"
      class="h-full w-auto max-w-full object-contain"
      :class="{ 'dark:hidden': globalConfig.logoDark }"
    />
    <img
      v-if="globalConfig.logoDark"
      :src="globalConfig.logoDark"
      :alt="globalConfig.installationName"
      class="hidden h-full w-auto max-w-full object-contain dark:block"
    />
  </span>
</template>
